import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCommunityFeed } from '../../hooks/useCommunity';
import CouponCard from '../../components/coupon/CouponCard';

const SORTS = [
  { key: 'top',    label: '🔥 Top',     desc: 'Most upvoted' },
  { key: 'new',    label: '🆕 New',     desc: 'Just submitted' },
  { key: 'rising', label: '📈 Rising',  desc: 'Gaining steam' },
];

export default function CommunityPage() {
  const [sort, setSort] = useState('top');
  const { deals, loading } = useCommunityFeed(sort, 36);

  return (
    <div>
      <section style={{ background: 'var(--hero-gradient)', color: '#fff', padding: '72px 0 48px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '-30%', right: '-10%', width: 420, height: 420, borderRadius: '50%', background: 'radial-gradient(circle, rgba(217,70,239,0.3) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div className="container" style={{ position: 'relative', textAlign: 'center' }}>
          <span className="chip" style={{ marginBottom: 18 }}>👥 Community-submitted</span>
          <h1 style={{ fontSize: 'clamp(32px, 4.4vw, 52px)', fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: 14 }}>
            Deals <span className="gradient-text">found by shoppers</span> like you.
          </h1>
          <p style={{ fontSize: 16, opacity: 0.85, maxWidth: 580, margin: '0 auto 22px' }}>
            Real-world finds, verified by the community. Upvote what worked. Comment with what saved you the most.
          </p>
          <Link to="/submit-coupon" className="btn btn-primary btn-lg">+ Submit a deal</Link>
        </div>
      </section>

      <div className="container" style={{ padding: '36px 20px 72px' }}>
        <div style={{ display: 'flex', gap: 10, marginBottom: 24, flexWrap: 'wrap' }}>
          {SORTS.map(s => (
            <button
              key={s.key}
              onClick={() => setSort(s.key)}
              style={{
                padding: '10px 18px',
                borderRadius: 999,
                border: sort === s.key ? '1.5px solid transparent' : '1.5px solid #E4E7F0',
                background: sort === s.key ? 'var(--brand-gradient)' : '#fff',
                color: sort === s.key ? '#fff' : '#0F1225',
                cursor: 'pointer',
                fontSize: 13,
                fontWeight: 700,
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
              title={s.desc}
            >
              {s.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
            <div className="spinner" style={{ width: 36, height: 36 }} />
          </div>
        ) : deals.length === 0 ? (
          <div style={{ background: '#fff', borderRadius: 18, padding: '64px 24px', textAlign: 'center', border: '1px solid #E4E7F0' }}>
            <p style={{ fontSize: 48, marginBottom: 14 }}>🌱</p>
            <h3 style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 8 }}>No community deals yet</h3>
            <p style={{ color: '#4A5568', marginBottom: 20 }}>Be the first to share a deal that worked for you.</p>
            <Link to="/submit-coupon" className="btn btn-primary">Submit a deal →</Link>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
            {deals.map(c => <CouponCard key={c.id} coupon={c} />)}
          </div>
        )}
      </div>
    </div>
  );
}
